module.exports = __webpack_public_path__ + "img/search.1a54085e.svg";